import { render, staticRenderFns } from "./OrderNotesCard.vue?vue&type=template&id=ad5e1cc0&"
import script from "./OrderNotesCard.vue?vue&type=script&lang=js&"
export * from "./OrderNotesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports